const ALL_GLOBAL_VARIABLES = {
  useAPI: true,
};

export default ALL_GLOBAL_VARIABLES;
